
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';

import { NotificationManager } from 'react-notifications';
import {
    COMMON_ACTION,
    ALL_STUDENT,
    ALL_ADMINMEMBERS,
    ALL_ACADEMYADMINLIST,
    ALL_GOLFCOACHMEMBERS,
    ALL_ACADEMYGOLFCOACH,
    ALL_SSCOACHMEMBERS,
    ALL_ACADEMYSSCOACH,
    ALL_PSYCHOLOGISTMEMBERS,
    ALL_ACADEMYPSYCHOLOGIST,
    ALL_NUTRITIONISTMEMBERS,
    ALL_ACADEMYNUTRITIONIST,
    ALL_ACADEMYSTUDENT,
    ALL_CLUB,
    ALL_PUTTINGEVALUATION,
    STUDENT_FULLDETAILS,
    ALL_MENU_LIST,
    PARENT_FULLDETAILS,
    CONTRACT_ALL_COUNT,
} from 'Actions/types';

export const pageReload = () =>{
    const login= AuthHeader.gettoke;    
    if(login==null){
         window.location.reload(true);
    }    
}

export const allStudents = () =>{
    const login= AuthHeader.gettoke; 
    if(login==null){
         window.location.reload(true);
    }else{ 
        
        return (dispatch) => { 
            dispatch({ type: COMMON_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getstudentlist', { headers: AuthHeader.header })         
            .then(response => {             
                const allstudents=response.data.data;
                dispatch({ type: ALL_STUDENT, payload: allstudents });
            });
        }
    }    
   
}

export const allAdminMembers = () =>{    
   
    return (dispatch) => { 
        dispatch({ type: COMMON_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getadminmembers', { headers: AuthHeader.header })         
        .then(response => {             
            const allAdmin=response.data.data;
            dispatch({ type: ALL_ADMINMEMBERS, payload: allAdmin });
        });
    }    

}

export const allAcademyAdminList = (id) => async (dispatch) => {     
    
        var payload={
            "academy":id
         }
         dispatch({ type: COMMON_ACTION });
        axios.post(AppConfig.apiurl+'/api/getacademyadminlist', payload, { headers: AuthHeader.header })              
        .then(response => {             
            const allmembers=response.data.data;
            dispatch({ type: ALL_ACADEMYADMINLIST, payload: allmembers });
        });

}

export const allGolfCoachMembers = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: COMMON_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getgolfcoachmembers', { headers: AuthHeader.header })         
        .then(response => {             
            const allCoach=response.data.data;
            dispatch({ type: ALL_GOLFCOACHMEMBERS, payload: allCoach });
        });
    }    

}

export const allAcademyGolfCoachList = (id) => async (dispatch) => {     
    
    var payload={
        "academy":id
    }
    dispatch({ type: COMMON_ACTION });
    axios.post(AppConfig.apiurl+'/api/getacademygolfcoachlist', payload, { headers: AuthHeader.header })              
    .then(response => {             
        const allmembers=response.data.data;
        dispatch({ type: ALL_ACADEMYGOLFCOACH, payload: allmembers });
    });

}

export const allSSCoachMembers = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: COMMON_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getsscoachmembers', { headers: AuthHeader.header })         
        .then(response => {             
            const allCoach=response.data.data;
            dispatch({ type: ALL_SSCOACHMEMBERS, payload: allCoach });
        });
    }    

}

export const allAcademySSCoachList = (id) => async (dispatch) => {     
    
    var payload={
        "academy":id
    }
    dispatch({ type: COMMON_ACTION });
    axios.post(AppConfig.apiurl+'/api/getacademysscoachlist', payload, { headers: AuthHeader.header })              
    .then(response => {             
        const allmembers=response.data.data;
        dispatch({ type: ALL_ACADEMYSSCOACH, payload: allmembers });
    });

}

export const allPsychologistMembers = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: COMMON_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getpsychologistmembers', { headers: AuthHeader.header })         
        .then(response => {             
            const allCoach=response.data.data;
            dispatch({ type: ALL_PSYCHOLOGISTMEMBERS, payload: allCoach });
        });
    }    

}

export const allAcademyPsychologistList = (id) => async (dispatch) => {     
    
    var payload={
        "academy":id
    }
    dispatch({ type: COMMON_ACTION });
    axios.post(AppConfig.apiurl+'/api/getacademypsychologistlist', payload, { headers: AuthHeader.header })              
    .then(response => {             
        const allmembers=response.data.data;
        dispatch({ type: ALL_ACADEMYPSYCHOLOGIST, payload: allmembers });
    });

}

export const allNutritionistMembers = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: COMMON_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getnutritionistmembers', { headers: AuthHeader.header })         
        .then(response => {             
            const allCoach=response.data.data;
            dispatch({ type: ALL_NUTRITIONISTMEMBERS, payload: allCoach });
        });
    }    

}

export const allAcademyNutritionistList = (id) => async (dispatch) => {     
    
    var payload={
        "academy":id
    }
    dispatch({ type: COMMON_ACTION });
    axios.post(AppConfig.apiurl+'/api/getacademynutritionistlist', payload, { headers: AuthHeader.header })              
    .then(response => {             
        const allmembers=response.data.data;
        dispatch({ type: ALL_ACADEMYNUTRITIONIST, payload: allmembers });
    });

}

export const allAcademyStudentsList = (id) => async (dispatch) => {     
    
    var payload={
        "academy":id
    }
    dispatch({ type: COMMON_ACTION });
    axios.post(AppConfig.apiurl+'/api/getacademystudentlist', payload, { headers: AuthHeader.header })              
    .then(response => {             
        const allmembers=response.data.data;
        var resdata=response.data;
        dispatch({ type: ALL_ACADEMYSTUDENT, payload: allmembers });
        return Promise.resolve(resdata);
    });

}



export const allClubs = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: COMMON_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getclublist', { headers: AuthHeader.header })         
        .then(response => {             
            const allclub=response.data.data;
            dispatch({ type: ALL_CLUB, payload: allclub });
        });
    }
    

}

export const allPuttingEvaluationlist = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: COMMON_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getputtinglessonlist', { headers: AuthHeader.header })         
        .then(response => {             
            const allclub=response.data.data;
            dispatch({ type: ALL_PUTTINGEVALUATION, payload: allclub });
        });
    }
    

}

export const StudentsFullDetails = (id) => async (dispatch) => {     
    
    var payload={
        "id":id
    }
    dispatch({ type: COMMON_ACTION });
    axios.post(AppConfig.apiurl+'/api/getstudentfulldetails', payload, { headers: AuthHeader.header })              
    .then(response => {             
        const allmembers=response.data;
        var resdata=response.data;
        dispatch({ type: STUDENT_FULLDETAILS, payload: allmembers.data[0] });
        return Promise.resolve(resdata);
    });

}

export const allAssignStudentsList = (id) => async (dispatch) => {     
    
    var payload={
        "academy":id
    }
    dispatch({ type: COMMON_ACTION });
    axios.post(AppConfig.apiurl+'/api/getassignstudentlist', payload, { headers: AuthHeader.header })              
    .then(response => {             
        const allmembers=response.data.data;
        var resdata=response.data;
        dispatch({ type: ALL_ACADEMYSTUDENT, payload: allmembers });
        return Promise.resolve(resdata);
    });

}

export const roleMenuList = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: COMMON_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getrolemenulist', { headers: AuthHeader.header })         
        .then(response => {             
            const allMenu=response.data.data;
            dispatch({ type: ALL_MENU_LIST, payload: allMenu });
        });
    }    

}

export const ParentFullDetails = (id) => async (dispatch) => {     
    
    var payload={
        "id":id
    }
    dispatch({ type: COMMON_ACTION });
    axios.post(AppConfig.apiurl+'/api/getparentfulldetails', payload, { headers: AuthHeader.header })              
    .then(response => {             
        const allmembers=response.data;
        var resdata=response.data;
        dispatch({ type: PARENT_FULLDETAILS, payload: allmembers.data[0] });
        return Promise.resolve(resdata);
    });

}

export const contractDetailCount = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: COMMON_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getctfulldetails', { headers: AuthHeader.header })         
        .then(response => {             
            const alldetails=response.data.data;
            dispatch({ type: CONTRACT_ALL_COUNT, payload: alldetails });
        });
    }    

}

